import Select from "react-select";
import { FormGroup } from "reactstrap";

const SelectComponent = ({
  label,
  fieldName,
  array,
  stateValue,
  onChange,
  defaultValue,
  selectedOption,
  disabled,
}) => {
  return (
    <>
      <label>{label}</label>
      <FormGroup
        className={stateValue && stateValue.length !== 0 ? "has-danger" : ""}
      >
        <Select
          className="react-select primary"
          classNamePrefix="react-select"
          name={fieldName}
          onChange={onChange}
          options={array.map((option) => ({
            value: {
              ...option,
              toString: () => `${option.value}`,
            },
            label: `${option.label}`,
          }))}
          defaultValue={defaultValue}
          value={selectedOption}
          isDisabled={disabled}
        />{" "}
        <label className="error">{stateValue}</label>
      </FormGroup>
    </>
  );
};

export default SelectComponent;
